module.exports = __webpack_public_path__ + "static/media/boxCom3.ff9557fe.png";